import { createdStyledElement } from "~/sharedComponents/layout/createdStyledElement";

export const Box = createdStyledElement({ name: "Box" });
